import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { translateBackendErrorCode } from "@jti/fe-common";
import { CasAuthApi } from "@jti/rest-api";
import { Button, DEPRECATED_CustomSelect, DEPRECATED_TextArea, DEPRECATED_TextInput, FieldWrapper, Form, FormField, Recaptchabar, Toaster, useConfig, useForm, useTranslations, validationPatterns, } from "@jti/ui";
import PrivacyFormDialog from "./PrivacyFormDialog";
import "./PrivacyForm.scss";
const preparePayload = ({ firstName, lastName, email, query, requestType }, additionalPayload) => {
    const additionalPayloadObject = additionalPayload.reduce((acc, { key, value }) => {
        return {
            ...acc,
            [key]: value,
        };
    }, {});
    const requestTypes = requestType ? [requestType.value] : [];
    const language = document.documentElement.lang;
    return {
        language,
        firstName,
        lastName,
        email,
        requestTypes: requestTypes,
        additionalData: {
            requestDetails: query,
            ...additionalPayloadObject,
        },
    };
};
const MAX_INPUT_LENGTH = 256;
const PrivacyForm = ({ requestTypes = [], firstNameLabel, generalDisclaimer, lastNameLabel, emailLabel, popupDescription, popupTitle, queryLabel, queryPlaceholder, requestTypeLabel, requestTypePlaceholder, additionalPayload = [], }) => {
    const [isOpened, setIsOpened] = useState(false);
    const [pending, setPending] = useState(false);
    const [requestTypeOptions, setRequestTypeOptions] = useState([]);
    const config = useConfig();
    const { __ } = useTranslations();
    useEffect(() => {
        const options = requestTypes.map(({ requestTypeItem, requestTypeItemTranslation }) => {
            return {
                value: requestTypeItem,
                label: requestTypeItemTranslation || requestTypeItem,
            };
        });
        setRequestTypeOptions(options);
    }, [requestTypes]);
    const form = useForm({
        defaultValues: {
            firstName: "",
            lastName: "",
            email: "",
            requestType: null,
            query: "",
        },
    });
    const onSubmit = async (formValues) => {
        setPending(true);
        try {
            await CasAuthApi.init().dsarRequest(preparePayload(formValues, additionalPayload));
            setIsOpened(true);
        }
        catch (error) {
            const translatedError = translateBackendErrorCode(error?.error_code);
            const errorMessage = translatedError || error?.message;
            if (errorMessage) {
                toast.error(errorMessage);
            }
        }
        setPending(false);
    };
    const onCloseDialog = () => {
        setIsOpened(false);
        form.reset();
    };
    return (_jsxs("div", { className: "privacy-form__container", children: [_jsx("div", { className: "privacy-form__top-disclaimer", children: generalDisclaimer }), _jsxs(Form, { form: form, onSubmit: onSubmit, dataTestId: "privacyForm", children: [_jsx(FormField, { className: "privacy-form__input", validation: { required: __("privacy.form.required.message") }, dataTestId: "privacyFormFirstNameField", label: firstNameLabel, name: "firstName", render: ({ field }) => (_jsx(DEPRECATED_TextInput, { ...field, maxLength: MAX_INPUT_LENGTH, dataTestId: "privacyFormFirstNameInput" })) }), _jsx(FormField, { className: "privacy-form__input", validation: { required: __("privacy.form.required.message") }, dataTestId: "privacyFormLastNameField", label: lastNameLabel, name: "lastName", render: ({ field }) => (_jsx(DEPRECATED_TextInput, { ...field, maxLength: MAX_INPUT_LENGTH, dataTestId: "privacyFormLastNameInput" })) }), _jsx(FormField, { className: "privacy-form__input", validation: {
                            required: __("privacy.form.required.message"),
                            pattern: {
                                message: __("privacy.form.email.validation"),
                                value: validationPatterns.EMAIL_PATTERN,
                            },
                        }, dataTestId: "privacyFormEmailField", label: emailLabel, name: "email", render: ({ field }) => (_jsx(DEPRECATED_TextInput, { ...field, maxLength: MAX_INPUT_LENGTH, dataTestId: "privacyFormEmailInput" })) }), _jsx("div", { className: "privacy-form__select", children: _jsx(FieldWrapper, { id: "requestType", label: requestTypeLabel, error: form.formState.errors.requestType?.message, required: true, children: _jsx(DEPRECATED_CustomSelect, { name: "requestType", placeholder: requestTypePlaceholder, inputId: "privacyFormRequestTypeSelect", dataTestId: "privacyFormRequestTypeSelect", options: requestTypeOptions, validation: {
                                    required: __("privacy.form.requestType.required"),
                                }, isSearchable: false }) }) }), _jsx(FormField, { className: "privacy-form__textarea", validation: { required: __("privacy.form.query.required") }, dataTestId: "privacyFormQueryField", label: queryLabel, name: "query", render: ({ field }) => (_jsx(DEPRECATED_TextArea, { ...field, maxLength: MAX_INPUT_LENGTH, showCounter: true, placeholder: queryPlaceholder, dataTestId: "privacyFormQueryInput" })) }), _jsx("div", { className: "privacy-form__bottom-disclaimer", children: generalDisclaimer }), _jsx(Button, { color: "primary", type: "submit", isPending: pending, "data-testid": "privacyFormSendButton", children: __("privacy.form.button.send") }), config.reCaptchaEnabled && config.brandingInformationEnabled && _jsx(Recaptchabar, {})] }), _jsx(PrivacyFormDialog, { title: popupTitle, description: popupDescription, isOpened: isOpened, onClose: onCloseDialog }), _jsx(Toaster, {})] }));
};
export default PrivacyForm;
//# sourceMappingURL=PrivacyForm.js.map